import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconCornerUpLeftLine.tsx
const IconCornerUpLeftLine = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M19 10v9h-2v-7H6.828l3.95 3.95-1.414 1.415L3 11l6.364-6.364 1.414 1.414L6.828 10z"
	})]
});
var IconCornerUpLeftLine_default = forwardRef(IconCornerUpLeftLine);
//#endregion
export { IconCornerUpLeftLine_default as default };
